import { instance } from "services/axiosConfig";

export const addElementsToModulePromise = async (elementType, payload) => {
  try {
    const response = await instance.post(`/api/modulems/v1/dam/${elementType}/import`, payload);
    return response?.data;
  } catch (error) {
    console.error(`Error importing ${elementType}:`, error?.response?.data || error.message || error);
    // Optionally, throw a more descriptive error
    throw new Error(`Failed to import ${elementType}. ${error?.response?.data?.message || error.message}`);
  }
};

export const createModulePromise = async (payload) => {
  try {
    const response = await instance.post("/api/modulems/v1/modules", payload);
    return response?.data;
  } catch (error) {
    console.error("Error creating module:", error?.response?.data || error.message || error);
    throw new Error(`Failed to create module. ${error?.response?.data?.message || error.message}`);
  }
};
